import React from 'react';

function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-900 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-8 sm:py-12 md:py-16">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-light mb-4 sm:mb-6 md:mb-8 leading-tight px-2 text-white">
            Goldilocks is the safety<br />
            you've been searching for.
          </h2>
        </div>

        <div className="flex flex-col items-center space-y-8 mb-16 sm:mb-24 md:mb-32">
          <div className="flex items-center space-x-3">
            <img 
              src="/assets/goldilocks-logo-white.png" 
              alt="Goldilocks Smart Solutions" 
              className="h-12 w-auto object-contain logo-force-white"
            />
            <span className="text-xl font-medium text-white">Goldilocks Smart Solutions</span>
          </div>

          <div className="flex items-center space-x-8">
            <a 
              href="https://www.linkedin.com/company/goldilocks-smart-solutions-llc/?viewAsMember=true" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/70 hover:text-white transition-colors text-lg font-medium"
            >
              LinkedIn
            </a>
            <a 
              href="https://www.instagram.com/goldilockssmart/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/70 hover:text-white transition-colors text-lg font-medium"
            >
              Instagram
            </a>
          </div>
        </div>

        <div className="text-center text-white/70 text-sm">
          <p>© 2025 Goldilocks Smart Solutions. All rights reserved.</p>
          <p className="mt-2 flex items-center justify-center">
            <span className="mr-2">In Loving Memory Of Great Grandmother Mary</span>
            <span className="text-red-400">❤️</span>
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 overflow-hidden pointer-events-none">
        <div className="text-[20rem] md:text-[25rem] font-bold text-slate-800/20 leading-none whitespace-nowrap transform translate-y-1/3">
          GOLDILOCKS
        </div>
      </div>
    </footer>
  );
}

export default Footer; 